
export default function tooltip() {


    const tooltips = document.querySelectorAll('.js-tooltip');
    
    tooltip_resiaze();

    window.addEventListener('resize',function(){
      tooltip_resiaze();
    });

    function tooltip_resiaze() {
        if ( tooltip ) {
            for (let tooltip of tooltips ) {
                let tooltipText = tooltip.querySelector('.tooltip__text');
                if ( (window.innerWidth - tooltip.getBoundingClientRect().left) < 120 ) {
                    tooltipText?.classList.add("tooltip__text_offset");
                } else {
                    tooltipText?.classList.remove("tooltip__text_offset");
                }
            }
        }
    }
    


}